module.exports = __webpack_public_path__ + "static/media/saveTheDate.707bc9ec.jpg";